module.exports = __webpack_public_path__ + "img/race-page_1248.10ad1666.png";